'use strict';

exports.__esModule = true;
exports.default = MessageUs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageUs(props) {
  var className = props.className,
      color = props.color,
      messengerAppId = props.messengerAppId,
      pageId = props.pageId,
      children = props.children,
      size = props.size,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-messengermessageus',
        messenger_app_id: messengerAppId,
        page_id: pageId,
        color: color,
        size: size
      },
      children
    )
  );
}

MessageUs.defaultProps = {
  color: undefined,
  size: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=MessageUs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/MessageUs.js
// module id = 1014
// module chunks = 198517197184460